import { LocalizationContextBuilder } from '@amzn/arb-tools';
import { RadioGroupProps } from '@amzn/awsui-components-react';
import { SelectOptionInterface } from 'src/components/ParcelSearch/ParcelSearchTablePanel';

export const DEFAULT_LOCALE = navigator.language || 'en-US';
export const DEFAULT_LC_BUILDER = new LocalizationContextBuilder().withDefaultLocale(
  DEFAULT_LOCALE,
);

export enum Images {
  home = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEDmlDQ1BrQ0dDb2xvclNwYWNlR2VuZXJpY1JHQgAAOI2NVV1oHFUUPpu5syskzoPUpqaSDv41lLRsUtGE2uj+ZbNt3CyTbLRBkMns3Z1pJjPj/KRpKT4UQRDBqOCT4P9bwSchaqvtiy2itFCiBIMo+ND6R6HSFwnruTOzu5O4a73L3PnmnO9+595z7t4LkLgsW5beJQIsGq4t5dPis8fmxMQ6dMF90A190C0rjpUqlSYBG+PCv9rt7yDG3tf2t/f/Z+uuUEcBiN2F2Kw4yiLiZQD+FcWyXYAEQfvICddi+AnEO2ycIOISw7UAVxieD/Cyz5mRMohfRSwoqoz+xNuIB+cj9loEB3Pw2448NaitKSLLRck2q5pOI9O9g/t/tkXda8Tbg0+PszB9FN8DuPaXKnKW4YcQn1Xk3HSIry5ps8UQ/2W5aQnxIwBdu7yFcgrxPsRjVXu8HOh0qao30cArp9SZZxDfg3h1wTzKxu5E/LUxX5wKdX5SnAzmDx4A4OIqLbB69yMesE1pKojLjVdoNsfyiPi45hZmAn3uLWdpOtfQOaVmikEs7ovj8hFWpz7EV6mel0L9Xy23FMYlPYZenAx0yDB1/PX6dledmQjikjkXCxqMJS9WtfFCyH9XtSekEF+2dH+P4tzITduTygGfv58a5VCTH5PtXD7EFZiNyUDBhHnsFTBgE0SQIA9pfFtgo6cKGuhooeilaKH41eDs38Ip+f4At1Rq/sjr6NEwQqb/I/DQqsLvaFUjvAx+eWirddAJZnAj1DFJL0mSg/gcIpPkMBkhoyCSJ8lTZIxk0TpKDjXHliJzZPO50dR5ASNSnzeLvIvod0HG/mdkmOC0z8VKnzcQ2M/Yz2vKldduXjp9bleLu0ZWn7vWc+l0JGcaai10yNrUnXLP/8Jf59ewX+c3Wgz+B34Df+vbVrc16zTMVgp9um9bxEfzPU5kPqUtVWxhs6OiWTVW+gIfywB9uXi7CGcGW/zk98k/kmvJ95IfJn/j3uQ+4c5zn3Kfcd+AyF3gLnJfcl9xH3OfR2rUee80a+6vo7EK5mmXUdyfQlrYLTwoZIU9wsPCZEtP6BWGhAlhL3p2N6sTjRdduwbHsG9kq32sgBepc+xurLPW4T9URpYGJ3ym4+8zA05u44QjST8ZIoVtu3qE7fWmdn5LPdqvgcZz8Ww8BWJ8X3w0PhQ/wnCDGd+LvlHs8dRy6bLLDuKMaZ20tZrqisPJ5ONiCq8yKhYM5cCgKOu66Lsc0aYOtZdo5QCwezI4wm9J/v0X23mlZXOfBjj8Jzv3WrY5D+CsA9D7aMs2gGfjve8ArD6mePZSeCfEYt8CONWDw8FXTxrPqx/r9Vt4biXeANh8vV7/+/16ffMD1N8AuKD/A/8leAvFY9bLAAAARGVYSWZNTQAqAAAACAACARIAAwAAAAEAAQAAh2kABAAAAAEAAAAmAAAAAAACoAIABAAAAAEAAAAwoAMABAAAAAEAAAAwAAAAABFH+aIAAAICaVRYdFhNTDpjb20uYWRvYmUueG1wAAAAAAA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJYTVAgQ29yZSA2LjAuMCI+CiAgIDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+CiAgICAgIDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiCiAgICAgICAgICAgIHhtbG5zOnRpZmY9Imh0dHA6Ly9ucy5hZG9iZS5jb20vdGlmZi8xLjAvIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj40ODwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj40ODwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpzCL0SAAABWUlEQVRoBe1WgQ2EIAzUzw/wIzjCj+JGjsJIv8JvoBv418RLtB9BQEWTkjSlltLrFYhVZcMYMAayGBjHsYE4SA/hkLmDiM/rz0qeGwxwb8gcOMzFEF/I/87FkRQPYMKsD9yiEo8hezRJIHKCkNR5QMW6XA6WpFgg1Ox/8K2dROZ6+Px9EoicII0Odsv9ZB7rZ2ysfsQGHLUeBTcpez9TgqaYAfo1i+8AgmbHyUz7/ENd19/Z2uOnAOsge40il/gSz2iteyWU6m9XsnHUFpgvc4lTSbICUpnbKy74jOozt5ZY3x0dF/Jv3VevsyOkGTnbvn0HFm+qsKfP6tmMhvLpu3X7DlgBoZYf7f+7AzqhvhP6DHJ9aF3Iv3UfrqO2I0QmSmnrQCnmmdc6QCZKaetAKeaZ1zpAJkpp60Ap5pn39h2I/htl5Wfptb9f5r99B6wAttK0MWAMlGHgB7zeeT/89SN/AAAAAElFTkSuQmCC',
}

export interface ILanguage {
  id: string;
  text: string;
}

export const Languages: ILanguage[] = [
  {
    id: 'en-US',
    text: 'English',
  },
  {
    id: 'fr-FR',
    text: 'French',
  },
  {
    id: 'de-DE',
    text: 'German',
  },
  {
    id: 'es-ES',
    text: 'Spanish',
  },
  {
    id: 'pt-PT',
    text: 'Portuguese',
  },
  {
    id: 'it-IT',
    text: 'Italian',
  },
  {
    id: 'hi-IN',
    text: 'Hindi',
  },
  {
    id: 'ja-JP',
    text: 'Japanese',
  },
  {
    id: 'ar-AE',
    text: 'Arabic (U.A.E.)',
  },
  {
    id: 'ar-SA',
    text: 'Arabic (Saudi Arabia)',
  },
  {
    id: 'cs-CZ',
    text: 'Czech (Czech Republic)',
  },
  {
    id: 'en-AU',
    text: 'English (Australia)',
  },
  {
    id: 'en-CA',
    text: 'English (Canada)',
  },
  {
    id: 'en-GB',
    text: 'English (United Kingdom)',
  },
  {
    id: 'en-SG',
    text: 'English (Singapore)',
  },
  {
    id: 'es-MX',
    text: 'Spanish (Mexico)',
  },
  {
    id: 'fr-CA',
    text: 'French (Canada)',
  },
  {
    id: 'nl-NL',
    text: 'Dutch (Netherlands)',
  },
  {
    id: 'pl-PL',
    text: 'Polish (Poland)',
  },
  {
    id: 'sk-SK',
    text: 'Slovak (Slovakia)',
  },
  {
    id: 'tr-TR',
    text: 'Turkish (Turkey)',
  },
  {
    id: 'zh-CN',
    text: 'Chinese (S)',
  },
  {
    id: 'zh-TW',
    text: 'Chinese (T)',
  },
];

export const MIDWAY = {
  URL: 'https://midway-auth.amazon.com/SSO',
  SCOPE: 'openid',
  RESPONSE_TYPE: 'id_token',
  SENTRY_HANDLER_VERSION: 'MidwayNginxModule-1.3-1',
};

export enum QueryKeys {
  cameras = 'cameras',
  cameraLinks = 'cameraLinks',
  userSites = 'userSites',
}

export const StepOptions: RadioGroupProps.RadioButtonDefinition[] = [
  { label: 'Induct', value: 'Induct', },
  { label: 'Stow', value: 'Stow', },
  { label: 'Pick', value: 'Pick', },
  { label: 'Staging', value: 'Staging', },
];

export enum UserActionNames {
  AuthenticateUser = 'Authenticate User',
  AuthenticateUserError = 'Error: Authenticate User',
  CreateCameraLink = 'Create Camera Link',
  CreateCameraLinkError = 'Create Camera Link Error',
  DeleteCameraLink = 'Delete Camera Link',
  DeleteCameraLinkError = 'Delete Camera Link Error',
  UpdateCameraLink = 'Update Camera Link',
  UpdateCameraLinkError = 'Update Camera Link Error',
  SelectSite = 'Select Site',
  UIModeChange = 'UI Mode Change',
}

export const URLS = {
  Contact: 'https://w.amazon.com/index.php/SIDE#HContactus',
  GuardianHub: 'https://guardian.gso.amazon.dev/',
  RiverGuide: 'https://river.amazon.com/?org=AccSys&q0=605c02a4-4e1e-49d1-96a4-5e9b5017a1bf',
  SiteNotFound:
    'https://w.amazon.com/bin/view/SOT_Knowledge_Center/Video_Systems/Integrations/ParcelPlayback/#HNotseeingthesitesyouexpect3F',
  UserGuide:
    'https://w.amazon.com/bin/view/SOT_Knowledge_Center/Video_Systems/Integrations/ParcelPlayback/',
};
